import "./managecash.scss";
import * as React from "react";
import { currency } from "#/Utilities/Generic/Numbers.ts";
import { formatDateTime } from "#/Utilities/Generic/Strings.ts";
import NoTranslate from "../../../Common/NoTranslate";
import type { DenominationsType } from "./ManageCash";

interface Props {
    amount: number;
    user: string;
    timestamp: string;
    reason: string;
    register: string;
    outlet: string;
    denominations?: DenominationsType;
}

export default class MovementPrint extends React.Component<Props> {
    protected formatDenominations(denominations: DenominationsType): Array<{
        denomination: string;
        in: string;
        out: string;
    }> {
        const formatted: Array<{
            denomination: string;
            in: string;
            out: string;
            value: number;
        }> = [];
        const data: Record<string, {
            in: number;
            out: number;
        }> = {};

        for(let i = 0, l = denominations.in.length; i < l; i++) {
            data[denominations.in[i].denomination] = {
                in : denominations.in[i].amount,
                out: 0,
            };
        }

        for(let i = 0, l = denominations.out.length; i < l; i++) {
            if(typeof data[denominations.out[i].denomination] === "undefined") {
                data[denominations.out[i].denomination] = {
                    in : 0,
                    out: denominations.out[i].amount,
                };
            } else {
                data[denominations.out[i].denomination].out = denominations.out[i].amount;
            }
        }

        for(const i in data) {
            if(!Object.prototype.hasOwnProperty.call(data, i)) {
                continue;
            }

            const value = parseFloat(i);

            formatted.push({
                denomination: currency(value),
                in          : `${data[i].in} (${currency(data[i].in * value)})`,
                out         : `${data[i].out} (${currency(data[i].out * value)})`,
                value,
            });
        }

        formatted.sort((a, b) => {
            return a.value - b.value;
        });

        return formatted;
    }

    public render(): React.ReactNode {
        let denominations;

        if(
            this.props.denominations &&
            (
                this.props.denominations.in.length !== 0 ||
                this.props.denominations.out.length !== 0
            )
        ) {
            const formatted = this.formatDenominations(this.props.denominations);

            denominations = (
                <React.Fragment>
                    <p>Denominations Swapped:</p>
                    <table>
                        <thead>
                            <tr>
                                <th>Denomination</th>
                                <th>In</th>
                                <th>Out</th>
                            </tr>
                        </thead>
                        <tbody>
                            {formatted.map(denomination => (
                                <tr key={denomination.denomination}>
                                    <td><NoTranslate>{denomination.denomination}</NoTranslate></td>
                                    <td>{denomination.in}</td>
                                    <td>{denomination.out}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </React.Fragment>
            );
        }

        return (
            <div className="movement-print">
                <p>{this.props.outlet}</p>
                <p>{this.props.register}</p>
                <table>
                    <tbody>
                        <tr>
                            <td>Amount</td>
                            <td><NoTranslate>{currency(this.props.amount)}</NoTranslate></td>
                        </tr>
                        <tr>
                            <td>User</td>
                            <td>{this.props.user}</td>
                        </tr>
                        <tr>
                            <td>Timestamp</td>
                            <td>{formatDateTime(this.props.timestamp)}</td>
                        </tr>
                    </tbody>
                </table>
                <p>Reason:</p>
                <p>{this.props.reason}</p>
                {denominations}
            </div>
        );
    }
}
